<template>
  <div>
    <el-dialog
      :title="openData.title"
      :visible.sync="openData.state"
      :close-on-click-modal="false"
      width="1200px"
      @close="dialogVisibleClone"
    >
      <div class="name-per">
        <div
          v-for="(item, index) in titleList"
          :key="index"
          class="name-list"
          @click="changeIdx(item.id)"
        >
          <div>
            <div
              class="name-title"
              :class="{
                changeColor: controlAddContent == item.id,
              }"
            >
              <div></div>
              <div><i class="el-icon-circle-check"></i></div>
              <div></div>
            </div>
            <div class="name-bottom">{{ item.name }}</div>
          </div>
        </div>
      </div>
      <!-- 基本信息 -->
      <el-form
        ref="addFormRef"
        :modal-append-to-body="false"
        :model="addForm"
        label-width="140px"
        :disabled="openData.title == '查看'"
      >
        <div v-show="controlAddContent == 1">
          <div class="addBox">
            <div style="width: 50%">
              <el-form-item label="机构名称:" prop="mechanismName">
                <el-input
                  v-model="addForm.mechanismName"
                  placeholder="请输入"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
              <el-form-item label="机构类型:" prop="mechanismType">
                <el-select
                  v-model="addForm.mechanismType"
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option label="养老机构" value="0"></el-option>
                  <el-option label="日间照料中心" value="1"></el-option>
                  <el-option
                    label="城乡居家养老机构(幸福院)"
                    value="2"
                  ></el-option>
                  <el-option label="合作服务商" value="3"></el-option>
                  <el-option label="其他" value="4"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="运行方式:" prop="operation">
                <el-select
                  v-model="addForm.operation"
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option label="村委会管理" value="0"></el-option>
                  <el-option label="协会管理" value="1"></el-option>
                  <el-option label="委托管理" value="2"></el-option>
                  <el-option label="其他" value="3"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="服务热线:" prop="hotline">
                <el-input
                  v-model="addForm.hotline"
                  placeholder="请输入"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
              <el-form-item label="核定医疗床位数:" prop="bedsNumber">
                <el-input
                  v-model="addForm.bedsNumber"
                  placeholder="请输入"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </div>
            <div style="width: 50%">
              <el-upload
                :disabled="openData.title == '查看'"
                :show-file-list="false"
                :action="actionUrl"
                list-type="picture-card"
                style="margin-left: 40%; margin-top: 10%"
              >
                <img v-if="addForm.head" :src="addForm.head" class="avatar" />
                <i v-else class="el-icon-plus"></i>
              </el-upload>
            </div>
          </div>
          <div class="addBox">
            <div style="width: 50%">
              <el-form-item label="建设状态:" prop="build">
                <el-select
                  v-model="addForm.build"
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option label="新建" value="1"></el-option>
                  <el-option label="改扩建" value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="联系方式:" prop="phone">
                <el-input
                  v-model="addForm.phone"
                  placeholder="请输入"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
              <el-form-item label="学历:">
                <!-- <el-input v-model="addForm.education" placeholder="请输入"></el-input> -->
                <el-select
                  v-model="addForm.education"
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option label="高中以下" value="0"></el-option>
                  <el-option label="专科" value="1"></el-option>
                  <el-option label="本科" value="2"></el-option>
                  <el-option label="研究生" value="3"></el-option>
                  <el-option label="博士" value="4"></el-option>
                  <el-option label="硕士" value="5"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="法人姓名:">
                <el-input
                  v-model="addForm.legalPerson"
                  placeholder="请输入"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="法人联系方式:"
                prop="legalPersonPhone"
                :rules="[
                  {
                    pattern: /^1[3|4|5|6|7|8|9]\d{9}$/,
                    message: '手机格式错误',
                    trigger: ['blur', 'change'],
                  },
                ]"
              >
                <el-input
                  v-model="addForm.legalPersonPhone"
                  placeholder="请输入"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </div>
            <div style="width: 50%">
              <el-form-item label="机构负责人:" prop="chargePerson">
                <el-input
                  v-model="addForm.chargePerson"
                  placeholder="请输入"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
              <el-form-item label="身份证号:" prop="idNumber">
                <el-input
                  v-model="addForm.idNumber"
                  placeholder="请输入"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
              <el-form-item label="民族:">
                <el-select
                  v-model="addForm.nation"
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option
                    :label="item"
                    :value="item"
                    v-for="(item, index) in nation"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="法人身份证号:"
                prop="legalPersonIds"
                :rules="[
                  {
                    pattern:
                      /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
                    message: '身份证号格式错误',
                    trigger: ['blur', 'change'],
                  },
                ]"
              >
                <el-input
                  v-model="addForm.legalPersonIds"
                  placeholder="请输入"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
              <el-form-item label="性别:">
                <el-select
                  v-model="addForm.sex"
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option label="男" value="1"></el-option>
                  <el-option label="女" value="2"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
          <div class="addressFrom">
            <div class="addressTitle"><span>*</span>机构地址:</div>
            <div class="addressContent">
              <div class="addressBox">
                <div class="addressItem">
                  <el-form-item prop="shengId">
                    <el-select
                      v-model="addForm.shengId"
                      :disabled="
                        normalInfo.orgLevel == 1 ||
                        normalInfo.orgLevel == 2 ||
                        normalInfo.orgLevel == 3 ||
                        normalInfo.orgLevel == 4 ||
                        normalInfo.orgLevel == 5
                      "
                      placeholder="请选择省"
                      @change="handleProvince"
                      ref="selectShengChange"
                    >
                      <el-option
                        v-for="(item, index) in provinceList"
                        :key="index"
                        :label="item.name"
                        :value="item.adcode"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="addressItem">
                  <el-form-item prop="shiId">
                    <el-select
                      :disabled="
                        normalInfo.orgLevel == 2 ||
                        normalInfo.orgLevel == 3 ||
                        normalInfo.orgLevel == 4 ||
                        normalInfo.orgLevel == 5
                      "
                      v-model="addForm.shiId"
                      placeholder="请选择市"
                      @change="handleCity"
                      ref="selectShiChange"
                    >
                      <el-option
                        v-for="(item, index) in cityList"
                        :key="index"
                        :label="item.name"
                        :value="item.adcode"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="addressItem">
                  <el-form-item prop="quId">
                    <el-select
                      :disabled="
                        normalInfo.orgLevel == 3 ||
                        normalInfo.orgLevel == 4 ||
                        normalInfo.orgLevel == 5
                      "
                      v-model="addForm.quId"
                      placeholder="请选择区"
                      @change="handleArea"
                      ref="selectQuChange"
                    >
                      <el-option
                        v-for="(item, index) in areaList"
                        :key="index"
                        :label="item.name"
                        :value="item.adcode"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="addressItem">
                  <el-form-item prop="jiedaoId">
                    <el-select
                      :disabled="
                        normalInfo.orgLevel == 4 || normalInfo.orgLevel == 5
                      "
                      v-model="addForm.jiedaoId"
                      placeholder="请选择街道"
                      @change="streetChange"
                      ref="selectJiedaoChange"
                    >
                      <el-option
                        v-for="(item, index) in streetList"
                        :key="index"
                        :label="item.name"
                        :value="item.adcode + index"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="addressItem">
                  <el-form-item prop="shequId">
                    <el-select
                      :disabled="normalInfo.orgLevel == 5"
                      v-model="addForm.shequId"
                      placeholder="请选择社区"
                      ref="selectShequChange"
                      @change="handleCommunityChange"
                    >
                      <el-option
                        v-for="item in communityList"
                        :key="item.id"
                        :label="item.address"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <el-form-item prop="address">
                <input
                  v-model.trim="addForm.address"
                  :disabled="openData.title == '查看'"
                  id="tipinput"
                  class="el-input__inner"
                  :class="openData.title == '查看' ? 'innerCur' : ''"
                  @focus="getMap('tipinput')"
                  placeholder="请输入关键字"
                  autocomplete="off"
                />
              </el-form-item>
              <div class="map_container">
                <div id="containervs" style="width: 100%; height: 300px"></div>
              </div>
            </div>
          </div>
        </div>
        <div v-show="controlAddContent == 2">
          <span style="color: #409eff">运营信息</span>
          <hr style="margin-bottom: 20px" />
          <div class="addBox">
            <div style="width: 50%">
              <el-form-item label="运营模式:">
                <el-select
                  v-model="addForm.operationMode"
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option label="公办公营" value="1"></el-option>
                  <el-option label="公办民营" value="2"></el-option>
                  <el-option label="民办民营" value="3"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="医疗服务方式:">
                <el-select
                  v-model="addForm.serviceMode"
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option label="内设医务室" value="0"></el-option>
                  <el-option label="与医疗机构合作" value="1"></el-option>
                  <el-option label="未开展" value="2"></el-option>
                  <el-option label="其他" value="3"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="接收异地老年人:">
                <el-select
                  v-model="addForm.isElderlyOtherPlaces"
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option label="是" value="1"></el-option>
                  <el-option label="否" value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="统一社会信用代码:">
                <el-input
                  v-model="addForm.socialCreditCode"
                  placeholder="请输入"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
              <el-form-item label="运营时间:">
                <el-date-picker
                  v-model="addForm.operationTime"
                  type="datetime"
                  placeholder="请选择时间"
                  clearable
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="兴办主体:">
                <el-select
                  v-model="addForm.initiatingBody"
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option label="省级民政部门" value="1"></el-option>
                  <el-option label="地级民政部门" value="1"></el-option>
                  <el-option label="县级民政部门" value="1"></el-option>
                  <el-option label="单位,企业或社团" value="1"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div style="width: 50%">
              <el-form-item label="具备医疗资质:" label-width="180px">
                <el-select
                  v-model="addForm.medicalQualifications"
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option label="是" value="1"></el-option>
                  <el-option label="否" value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="具备医保定点定点资格:" label-width="180px">
                <el-select
                  v-model="addForm.insuranceQualification"
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option label="是" value="1"></el-option>
                  <el-option label="否" value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="养老机构设立许可证编码:" label-width="180px">
                <el-input
                  v-model="addForm.institutionAgreeNumber"
                  placeholder="请输入"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
              <el-form-item label="机构代码证编号:" label-width="180px">
                <el-input
                  v-model="addForm.institutionalCardNumber"
                  placeholder="请输入"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
              <el-form-item label="登记性质:" label-width="180px">
                <el-select
                  v-model="addForm.registrationNature"
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option label="营利" value="1"></el-option>
                  <el-option label="非营利" value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="投资额:" label-width="180px">
                <el-input
                  v-model="addForm.investmentAmount"
                  placeholder="请输入"
                  style="width: 100%"
                  type="number"
                  :min="0"
                  oninput="if(value<0)value=''"
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <span style="color: #409eff">场地信息</span>
          <hr style="margin-bottom: 20px" />
          <div class="addBox">
            <div style="width: 50%">
              <el-form-item label="房屋产权:">
                <el-select
                  v-model="addForm.housingProperty"
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option label="自有" value="1"></el-option>
                  <el-option label="租赁" value="2"></el-option>
                  <el-option label="其他" value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="单人间数:">
                <el-input
                  v-model="addForm.singleRoomNumber"
                  placeholder="请输入"
                  style="width: 100%"
                  type="number"
                  :min="0"
                  oninput="if(value<0)value=''"
                ></el-input>
              </el-form-item>
              <el-form-item label="三人间数:">
                <el-input
                  v-model="addForm.tripleRoomNumber"
                  placeholder="请输入"
                  style="width: 100%"
                  type="number"
                  :min="0"
                  oninput="if(value<0)value=''"
                ></el-input>
              </el-form-item>
              <el-form-item label="房间总数:">
                <el-input
                  v-model="addForm.elderlyRoomNumber"
                  placeholder="请输入"
                  style="width: 100%"
                  type="number"
                  :min="0"
                  oninput="if(value<0)value=''"
                ></el-input>
              </el-form-item>
              <el-form-item label="建筑面积(平方米):">
                <el-input
                  v-model="addForm.builtArea"
                  placeholder="请输入"
                  style="width: 100%"
                  type="number"
                  :min="0"
                  oninput="if(value<0)value=''"
                ></el-input>
              </el-form-item>
            </div>
            <div style="width: 50%">
              <el-form-item label="房屋类型:">
                <el-select
                  v-model="addForm.housingType"
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option label="楼房" value="1"></el-option>
                  <el-option label="平房" value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="双人间数:">
                <el-input
                  v-model="addForm.doubleRoomNumber"
                  placeholder="请输入"
                  style="width: 100%"
                  type="number"
                  :min="0"
                  oninput="if(value<0)value=''"
                ></el-input>
              </el-form-item>
              <el-form-item label="多人间数:">
                <el-input
                  v-model="addForm.multiplayerRoomNumber"
                  placeholder="请输入"
                  style="width: 100%"
                  type="number"
                  :min="0"
                  oninput="if(value<0)value=''"
                ></el-input>
              </el-form-item>
              <el-form-item label="占地面积(平方米):">
                <el-input
                  v-model="addForm.coverage"
                  placeholder="请输入"
                  style="width: 100%"
                  type="number"
                  :min="0"
                  oninput="if(value<0)value=''"
                ></el-input>
              </el-form-item>
            </div>
          </div>
        </div>
        <div v-show="controlAddContent == 3">
          <el-button
            type="success"
            icon="iconfont icon-xinzeng"
            @click="showAddDialog('新增')"
            >新增</el-button
          >

          <div style="height: 20px"></div>

          <el-table
            :data="addForm.prizeList"
            border
            style="width: 100%"
            :header-cell-style="{
              background: '#f2f2f2',
              color: '#000',
            }"
          >
            <el-table-column
              type="index"
              label="序号"
              width="100"
              align="center"
              :show-overflow-tooltip="true"
            ></el-table-column>

            <el-table-column
              prop="name"
              label="名称"
              align="center"
              :show-overflow-tooltip="true"
            ></el-table-column>

            <el-table-column
              prop="number"
              label="编号"
              align="center"
              :show-overflow-tooltip="true"
            ></el-table-column>

            <el-table-column
              prop="time"
              label="时间"
              align="center"
              :show-overflow-tooltip="true"
            ></el-table-column>

            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-row>
                  <el-col :span="6">
                    <el-link
                      :underline="false"
                      @click="showAddDialog('查看', scope.row)"
                      >查看</el-link
                    >
                  </el-col>
                </el-row>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ["openData"],
  data() {
    return {
      titleList: [
        {
          id: "1",
          name: "基本信息",
        },
        {
          id: "2",
          name: "运营信息",
        },
        {
          id: "3",
          name: "获奖信息",
        },
      ],
      controlAddContent: 1,
      addForm: {},
      actionUrl: "",
      nation: [
        //民族
        "汉族",
        "蒙古族",
        "回族",
        "藏族",
        "维吾尔族",
        "苗族",
        "彝族",
        "壮族",
        "布依族",
        "朝鲜族",
        "满族",
        "侗族",
        "瑶族",
        "白族",
        "土家族",
        "哈尼族",
        "哈萨克族",
        "傣族",
        "黎族",
        "傈僳族",
        "佤族",
        "畲族",
        "高山族",
        "拉祜族",
        "水族",
        "东乡族",
        "纳西族",
        "景颇族",
        "柯尔克孜族",
        "土族",
        "达斡尔族",
        "仫佬族",
        "羌族",
        "布朗族",
        "撒拉族",
        "毛南族",
        "仡佬族",
        "锡伯族",
        "阿昌族",
        "普米族",
        "塔吉克族",
        "怒族",
        "乌孜别克族",
        "俄罗斯族",
        "鄂温克族",
        "德昂族",
        "保安族",
        "裕固族",
        "京族",
        "塔塔尔族",
        "独龙族",
        "鄂伦春族",
        "赫哲族",
        "门巴族",
        "珞巴族",
        "基诺族",
        "其他",
        "外籍血统中国籍人士",
      ],
      normalInfo: {},
      provinceList: [],
      cityList: [],
      areaList: [],
      streetList: [],
      polygons: [],
      communityList: [],
      myMap: null,
      isMap: true,
      imgTitleList: [],
      dialogVisible1: false,
    }
  },
  created() {
    this.setDialogWidth()
    setTimeout(async () => {
      await this.$nextTick(() => this.loadMap())
    }, 30)
    this.gethuixian()
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.setDialogWidth()
      })()
    }
  },
  methods: {
    gethuixian() {
      this.changeFirst()
      this.$http
        .request({
          url: "/jgyl/admin/institute/info/get",
          method: "POST",
          data: {
            id: this.openData.id,
          },
        })
        .then(async (res) => {
          if (res.code == 200) {
            if (res.content) {
              const content = res.content
              //   this.handleImgGet(content)
              //   console.log(this.imgTitleList)
              //   // 回显图片
              //   this.imgTitleList.forEach((item) => {
              //     if (content[item] && Array.isArray(content[item])) {
              //       content[item].forEach((item2) => {
              //         this[item].push({
              //           name: item2.substring(this.actionUrl + 18),
              //           url: item2,
              //         })
              //       })
              //     }
              //   })
              if (content.shengId) {
                content.shengId = String(content.shengId)
              }
              if (content.shiId) {
                content.shiId = String(content.shiId)
              }
              if (content.quId) {
                content.quId = String(content.quId)
              }
              if (content.jiedaoId) {
                content.jiedaoId = String(content.jiedaoId)
              }
              if (content.shequId) {
                content.shequId = Number(content.shequId)
              }
              this.addForm = res.content
              if (!this.addForm.shengId) return
              let city = await this.getDistricts(this.addForm.shengId)
              this.cityList = city.districtList
              console.log(this.cityList)
              if (!this.addForm.shiId) return
              let area = await this.getDistricts(this.addForm.shiId)
              this.areaList = area.districtList
              console.log(this.areaList, "区")
              if (!this.addForm.quId) return
              let street = await this.getDistricts(this.addForm.quId)
              this.streetList = street.districtList
              if (!this.addForm.jiedaoId) return
              let communityList = await this.getCommityList(
                this.addForm.jiedaoId
              )
              this.addForm.shequId = Number(this.addForm.shequId)
              if (this.addForm.shequId == 0) {
                this.addForm.shequId = ""
              }
              this.communityList = communityList
              this.addForm.nation = content.nation //民族
              if (this.addForm.addressLat && this.addForm.addressLng) {
                this.potintMap()
              }
            }
          } else {
            this.$message({
              message: "根据ID获取信息失败",
              type: "error",
            })
          }
        })
    },
    showAddDialog() {},
    // 获取时处理图片
    handleImgGet(element) {
      this.imgTitleList.forEach((item, index) => {
        if (!element[item]) {
          element[item] = []
          return
        }
        element[item] = element[item].split("#")
        element[item].map((item1, index) => {
          if (item1 == "") {
            element[item].splice(index, 1)
          }
        })
      })
    },
    dialogVisibleClone() {
      this.$emit("cancleService", false)
    },
    changeIdx(id) {
      this.controlAddContent = id
    },
    closeImgs() {
      this.dialogVisible1 = false
    },
    // 预览图片
    handlePicturePreview(file) {
      this.dialogVisible1 = true
      this.dialogImageUrl = file.url
    },
    // 图片上传成功
    imgSuccess(type, data, data1, data2) {
      if (data.code === 200) {
        this.addForm[type].push(data.content)
      }
    },
    //上传图片方法
    handleRemove2(type, file, fileList) {
      this.addForm[type].map((item, index) => {
        if (file.response != undefined) {
          if (item == file.response.content) {
            this.addForm[type].splice(index, 1)
          }
        } else {
          if (item == file.url) {
            this.addForm[type].splice(index, 1)
          }
        }
      })
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个图片，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      )
    },
    loadMap() {
      //地图加载
      return new Promise((resolve, reject) => {
        this.myMap = new AMap.Map(containervs, {
          resizeEnable: true,
          zoom: 18,
        })
        this.myMap.on("complete", () => {
          console.log("地图图块加载完毕")
          resolve()
        })
      })
    },
    // 五级联动地图方法
    async handleProvince(val) {
      this.cityList = []
      this.areaList = []
      this.streetList = []
      this.communityList = []
      this.addForm.shiId = ""
      this.addForm.quId = ""
      this.addForm.jiedaoId = ""
      this.addForm.shequId = ""
      this.addForm.address = ""
      let city = await this.getDistricts(val)
      this.cityList = city.districtList
      this.joinAddress()
    },
    async getProvince() {
      this.provinceLis = []
      this.cityList = []
      this.areaList = []
      this.streetList = []
      let province = await this.getDistricts()
      this.provinceList = province.districtList
    },
    //市级地址发生改变
    async handleCity(val) {
      this.areaList = []
      this.streetList = []
      this.communityList = []
      this.addForm.quId = ""
      this.addForm.jiedaoId = ""
      this.addForm.shequId = ""
      this.addForm.address = ""
      let area = await this.getDistricts(val)
      this.areaList = area.districtList
      this.joinAddress()
    },
    //县区级地址发生改变
    async handleArea(val) {
      this.streetList = []
      this.communityList = []
      this.addForm.jiedaoId = ""
      this.addForm.shequId = ""
      this.addForm.address = ""
      // val = val.replace(/.$/, "");
      let street = await this.getDistricts(val)
      this.streetList = street.districtList
      this.joinAddress()
    },
    //街道地址发生变化
    async streetChange(val) {
      let communityList = await this.getCommityList(val)
      this.communityList = communityList
      this.joinAddress()
    },
    // 社区地址列表
    getCommityList(val) {
      let self = this
      return new Promise((resolve, reject) => {
        self.$http
          .request({
            url: "/ypt/admin/standardAddress/info/StandardAddressTree",
            method: "POST",
            data: {
              jiedaoId: val,
            },
          })
          .then((res) => {
            if (res.code == 200) {
              if (!res.content) {
                resolve([])
                return
              }
              resolve(res.content)
            } else {
              resolve([])
            }
          })
      }).catch((err) => {
        console.log(err)
      })
    },
    handleCommunityChange(val) {
      this.$nextTick(() => {
        this.$forceUpdate()
        this.joinAddress()
      })
    },
    // 打点
    potintMap() {
      const self = this
      try {
        self.myMap.remove(self.marker)
      } catch (err) {
        console.log(err)
      }
      self.marker = new AMap.Marker({
        icon: "http://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
        position: [
          Number(self.addForm.addressLng),
          Number(self.addForm.addressLat),
        ],
      })
      self.myMap.add(self.marker)
      self.myMap.setFitView()
    },
    //获取地址
    getDistricts(name = "中国", params = null) {
      let self = this
      return new Promise((resolve, reject) => {
        var opts = {
          subdistrict: 1, //返回下一级行政区
          extensions: "all",
          showbiz: false, //最后一级返回街道信息
        }
        let district = new AMap.DistrictSearch(opts)
        let geocoder = new AMap.Geocoder({
          city: "", //城市设为北京，默认：“全国”
          radius: 1000, //范围，默认：500
        })
        try {
          self.myMap.remove(self.marker)
        } catch (err) {
          // console.log(err);
        }

        self.marker = new AMap.Marker()
        district.search(name, (status, result) => {
          if (status == "complete") {
            resolve(result.districtList[0])
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    // 地图
    getMap(input) {
      const self = this
      const autoOptions = {
        city: this.addForm.quId,
        citylimit: true,
        input: input,
      }
      // alert(input)
      const auto = new AMap.Autocomplete(autoOptions)
      //构造地点查询类
      AMap.event.addListener(auto, "select", (e) => {
        self.addForm.address = e.poi.name
        self.addForm.addressLng = e.poi.location.lng
        self.addForm.addressLat = e.poi.location.lat
        console.log(e.poi.location, "地址")
        self.potintMap()
      })
    },
    setDialogWidth() {
      console.log(document.body.clientWidth)
      var val = document.body.clientWidth
      const def = 1200 // 默认宽度
      if (val < def) {
        this.dialogWidth = "100%"
      } else {
        this.dialogWidth = def + "px"
      }
    },
    async changeFirst() {
      let province = await this.getDistricts()
      this.provinceList = province.districtList
      if (this.normalInfo.provinceId == 0) {
        this.normalInfo.provinceId = ""
      } else {
        this.normalInfo.provinceId = String(this.normalInfo.provinceId)
        let cityList = await this.getDistricts(this.normalInfo.provinceId)
        this.cityList = cityList.districtList
        console.log("城市", this.cityList)
      }
      if (this.normalInfo.cityId) {
        this.normalInfo.cityId = String(this.normalInfo.cityId)
        let areaList = await this.getDistricts(this.normalInfo.cityId)
        this.areaList = areaList.districtList
      } else {
        this.normalInfo.cityId = ""
      }

      if (this.normalInfo.areaId) {
        this.normalInfo.areaId = String(this.normalInfo.areaId)
        let streetList = await this.getDistricts(this.normalInfo.areaId)
        this.streetList = streetList.districtList
      } else {
        this.normalInfo.areaId = ""
      }
      if (this.normalInfo.streetId) {
        this.normalInfo.streetId = String(this.normalInfo.streetId)
        let communityList = await this.getCommityList(this.normalInfo.streetId)
        this.communityList = communityList
      } else {
        this.normalInfo.streetId = ""
      }
      if (this.normalInfo.orgLevel == 1 || this.normalInfo.orgLevel == 0) {
        this.provinceList.forEach((item) => {
          if (item.adcode == this.normalInfo.provinceId) {
            this.addForm.addressLat = item.center.lat
            this.addForm.addressLng = item.center.lng
          }
        })
      } else if (this.normalInfo.orgLevel == 2) {
        this.cityList.forEach((item) => {
          if (item.adcode == this.normalInfo.cityId) {
            this.addForm.addressLat = item.center.lat
            this.addForm.addressLng = item.center.lng
          }
        })
      } else if (this.normalInfo.orgLevel == 3) {
        this.areaList.forEach((item) => {
          if (item.adcode == this.normalInfo.areaId) {
            this.addForm.addressLat = item.center.lat
            this.addForm.addressLng = item.center.lng
          }
        })
      } else if (
        this.normalInfo.orgLevel == 4 ||
        this.normalInfo.orgLevel == 5
      ) {
        this.streetList.forEach((item, index) => {
          if (item.adcode + index == this.normalInfo.streetId) {
            this.addForm.addressLat = item.center.lat
            this.addForm.addressLng = item.center.lng
          }
        })
      }
      // this.potintMap()

      if (this.normalInfo.communityId) {
        this.normalInfo.communityId = String(this.normalInfo.communityId)
      } else {
        this.normalInfo.communityId = ""
      }
      this.addForm.shengId = this.normalInfo.provinceId
      this.addForm.shiId = this.normalInfo.cityId
      this.addForm.quId = this.normalInfo.areaId
      this.addForm.jiedaoId = this.normalInfo.streetId
      this.addForm.shequId = Number(this.normalInfo.communityId)
      this.loadMap("containervs")
      setTimeout(() => {
        this.potintMap()
      }, 500)
      this.$forceUpdate()
      // console.log(this.normalInfo, "机构信息",this.)
    },
  },
}
</script>

<style lang="less" scoped>
.name-per {
  width: 90%;
  margin: 0 auto;
  display: flex;
  margin-bottom: 20px;
}

.name-list {
  width: 50%;
  cursor: pointer;
  display: flex;
  justify-content: center;
}

.name-list > div:first-child {
  width: 100%;
}

.name-title {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.name-title > div:first-child {
  width: 50%;
  height: 2px;
  background-color: #eeeeee;
}

.name-title > div:last-child {
  width: 50%;
  height: 2px;
  background-color: #eeeeee;
}

.changeColor > div:first-child {
  background-color: #0000ff;
}

.changeColor > div:nth-child(2) {
  color: #0000ff;
}

.changeColor > div:last-child {
  background-color: #0000ff;
}

.name-bottom {
  text-align: center;
}
.addBox {
  display: flex;
  width: 100%;
  justify-content: flex-start;
}
/deep/.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

/deep/.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

/deep/.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}

/deep/.avatar {
  width: 148px;
  height: 148px;
  display: block;
}
.addressFrom {
  display: flex;
  margin-right: 10px;
  margin-bottom: 20px;
  .addressTitle {
    text-align: right;
    vertical-align: middle;
    width: 140px;
    font-size: 14px;
    color: #606266;
    line-height: 40px;
    padding: 0 12px 0 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    span {
      color: #f56c6c;
      margin-right: 4px;
    }
  }
  .addressContent {
    flex: 1;
    .addressBox {
      display: flex;
      .addressItem {
        flex: 1;
        /deep/.el-form-item__content {
          margin-left: 0px !important;
        }
        /deep/.el-select {
          width: 100% !important;
        }
      }
    }
    /deep/.el-form-item__content {
      margin-left: 0px !important;
    }
  }
}
</style>
